import { useEffect } from "react";

/**
 * Préremplit le slug depuis /portal/:slug
 */
export function usePortalSlugFromRoute(slugFromRoute, setSlug) {
  useEffect(() => {
    if (!slugFromRoute) return;
    try {
      const decoded = decodeURIComponent(slugFromRoute).trim().toLowerCase();
      if (decoded) setSlug(decoded);
    } catch {
      setSlug(slugFromRoute.trim().toLowerCase());
    }
  }, [slugFromRoute, setSlug]);
}
